import { render, staticRenderFns } from "./EditTgas.vue?vue&type=template&id=22dda20e&scoped=true&"
import script from "./EditTgas.vue?vue&type=script&lang=js&"
export * from "./EditTgas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dda20e",
  null
  
)

export default component.exports